module.exports = __webpack_public_path__ + "static/img/025_TO8_1517_og.64c3d45.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/025_TO8_1517_og.jpg
// module id = JIA9
// module chunks = 0